import { history } from '@src/configureHistory'
export class QueryStringParams {
    private readonly _p: any = null

    constructor(search: string) {
        this._p = QueryStringParams.parseQueryString(search)
    }

    public get = (key: string): string => {
        return this._p[key]
    }

    public getNumber = (key: string, defaultValue: number): number => {
        const val = this._p[key]
        return val !== undefined && val !== null ? parseFloat(val) : defaultValue
    }

    public getBool = (key: string, defaultValue: boolean): boolean => {
        const val = this._p[key]
        return val !== undefined && val !== null ? JSON.parse(val) : defaultValue
    }

    public isEmpty = (): boolean => {
        return Object.keys(this._p).length === 0
    }

    public static parseQueryString = (query: string): any => {
        if (!!query && query.indexOf('?') !== -1) {
            query = query.substr(query.indexOf('?'))
        }
        query = /^[?#]/.test(query) ? query.slice(1) : query
        return !!query
            ? query.split('&').reduce((params, param) => {
                  const [key, value] = param.split('=')
                  params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : ''
                  return params
              }, {})
            : {}
    }

    public static toQueryString = (param: any): string => {
        if (!param) {
            return ''
        }
        if (typeof param === 'string') {
            return ''
        }

        function serialize(obj, prefix = null): string {
            let str = []
            for (let p in obj) {
                if (obj.hasOwnProperty(p)) {
                    // let k = prefix ? prefix + "." + p : p
                    let k = prefix ? prefix + '[' + p + ']' : p
                    let v = obj[p]
                    str.push(
                        v !== null && typeof v === 'object'
                            ? serialize(v, k)
                            : encodeURIComponent(k) + '=' + encodeURIComponent(v)
                    )
                }
            }
            return str.join('&')
        }

        return serialize(param)

        /*query = Object.keys(query).reduce((params, p) => {
            return query[p] !== undefined && query[p] !== null
                ? {...params, [p]: query[p]}
                : params
        }, {})

        return Object.keys(query).map(key => [key, query[key]].map(encodeURIComponent).join('=')).join('&')*/
    }
}

/* 
    JUST GET OBJECT OF PATHAME LIKE:
    pathname : /wh/income/list/Order
    return : {
        params: ['wh', 'income', 'list', 'Order' ],
        lastParam: Order
    }
*/
export const getParamsFromPathname = (): {
    params: string[]
    lastParam: any
} => {
    const splitedParama = history.location.pathname.split('/')

    return {
        params: splitedParama,
        lastParam: splitedParama[splitedParama.length - 1]
    }
}
